import React from 'react'
import facebook from '../assets/facebk.svg'
import instagram from '../assets/insta.svg'
import twitter from '../assets/twitter.svg'

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <div
            className='h-[30px] lg:h-[40px] fixed md:h-fit z-10 w-full bg-white bottom-0 border-t border-[#d6d9df] py-2 px-2'>
            <div className='max-w-[1500px] flex items-center justify-between mx-auto'>
                <p>©{currentYear} All rights reserved.</p>

                {/* <div className='flex items-center md:gap-6 sm:gap-4 gap-3'>
              <img src={twitter} alt="" />
                  <img src={facebook} alt="" />
                  <img src={instagram} alt="" />
                  
              </div> */}
            </div>
        </div>
    )
}

export default Footer